import { render, staticRenderFns } from "./CardStudentExamInfo.vue?vue&type=template&id=4ac6172d&scoped=true&"
import script from "./CardStudentExamInfo.vue?vue&type=script&lang=js&"
export * from "./CardStudentExamInfo.vue?vue&type=script&lang=js&"
import style0 from "./CardStudentExamInfo.vue?vue&type=style&index=0&id=4ac6172d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac6172d",
  null
  
)

export default component.exports